import { render, staticRenderFns } from "./property-list-item.vue?vue&type=template&id=6e1f5dd5&scoped=true"
import script from "./property-list-item.vue?vue&type=script&lang=js"
export * from "./property-list-item.vue?vue&type=script&lang=js"
import style0 from "./property-list-item.vue?vue&type=style&index=0&id=6e1f5dd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1f5dd5",
  null
  
)

export default component.exports